import type { Coupon, CreateCouponData } from '../api/coupons.service';

export const TRIAL_DAYS_OPTIONS = [
  { value: 7, label: '7 dias' },
  { value: 15, label: '15 dias' },
  { value: 30, label: '30 dias' },
] as const;

export const DURATION_TYPE_LABELS: Record<string, string> = {
  ONCE: 'Apenas na primeira fatura',
  REPEATING: 'Nos primeiros X meses',
  FOREVER: 'Para sempre (vitalício)',
};

export function couponToFormData(c: Coupon): CreateCouponData {
  const s = c.discountStrategy;
  let discountStrategy: CreateCouponData['discountStrategy'] = 'PERCENTAGE';
  if (s === 'TRIAL_DAYS') discountStrategy = 'TRIAL_DAYS';
  else if (s === 'FIXED_AMOUNT') discountStrategy = 'FIXED_AMOUNT';
  return {
    code: c.code,
    discountStrategy,
    value: c.value,
    durationType: (c.durationType as CreateCouponData['durationType']) || 'ONCE',
    durationMonths: c.durationMonths ?? undefined,
    usageType: (c.usageType as CreateCouponData['usageType']) || 'CAMPAIGN',
    affiliateId: c.affiliateId,
    description: c.description || '',
    maxRedemptions: c.maxRedemptions ?? undefined,
    validFrom: c.validFrom ? c.validFrom.slice(0, 10) : undefined,
    validUntil: c.validUntil ? c.validUntil.slice(0, 10) : undefined,
    planIds: c.planIds ?? undefined,
  };
}

export function emptyCouponForm(): CreateCouponData {
  return {
    code: '',
    discountStrategy: 'TRIAL_DAYS',
    value: 30,
    durationType: 'ONCE',
    usageType: 'CAMPAIGN',
    description: '',
  };
}
